<template>
  <div class="min-h-full bg-gray-50">
    <div class="space-y-4">
    <!-- 搜索和筛选区域 -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-200/80 backdrop-blur-sm relative z-10">
      <div class="p-4">
          <!-- 第一行：搜索框和主要按钮 -->
          <div class="flex flex-col sm:flex-row gap-4 mb-4">
            <!-- 搜索框 -->
            <div class="flex-1">
              <div class="relative">
              <input
                v-model="searchQuery"
                type="text"
                placeholder="搜索账户名称或邮箱地址..."
                class="w-full h-10 pl-10 pr-4 text-sm bg-gray-50/50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 focus:bg-white transition-all duration-200 placeholder-gray-400"
                  @keyup.enter="handleSearch"
              >
              <MagnifyingGlassIcon class="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
              </div>
            </div>
            
            <!-- 筛选器组 -->
            <div class="flex gap-2">
            <!-- 分组筛选 -->
              <div class="flex-1 sm:w-56 sm:flex-initial">
                <SearchableSelect
                v-model="selectedGroup"
                  :options="groupOptions"
                  placeholder="全部分组"
                  label-key="name"
                  value-key="id"
                  @update:modelValue="handleSearch"
                />
              </div>
            <!-- 提供商筛选 -->
              <div class="flex-1 sm:w-56 sm:flex-initial">
                <SearchableSelect
                v-model="selectedProvider"
                  :options="providerOptions"
                  placeholder="全部提供商"
                  label-key="name"
                  value-key="id"
                  @update:modelValue="handleSearch"
                />
            </div>
          </div>
          
            <!-- 搜索和添加账户按钮 -->
            <div class="grid grid-cols-2 gap-2 sm:flex sm:gap-2">
            <button
              @click="handleSearch"
                :disabled="loading"
                class="inline-flex items-center justify-center h-10 px-4 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 hover:border-blue-300 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <MagnifyingGlassIcon class="h-4 w-4 mr-2" />
                搜索账户
            </button>
            <button
              v-if="canAddEmailAccount"
              @click="handleAddAccount"
                class="inline-flex items-center justify-center h-10 px-4 text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg hover:from-blue-700 hover:to-blue-800 focus:ring-2 focus:ring-blue-500/20 focus:ring-offset-2 shadow-sm hover:shadow-md transform hover:scale-105 transition-all duration-200"
            >
                <PlusIcon class="h-4 w-4 mr-2" />
              添加账户
            </button>
          </div>
        </div>
            
          <!-- 第二行：管理按钮 -->
          <div class="flex flex-col sm:flex-row gap-4">
            <!-- 管理按钮 -->
            <div class="flex flex-col gap-2 sm:flex-row sm:gap-2">
              <!-- 第一排：分组管理 + 自定义（手机端1/2宽度，桌面端正常） -->
              <div class="grid grid-cols-2 gap-2 sm:flex sm:gap-2">
            <button
                  @click="handleManageGroups"
                  class="inline-flex items-center justify-center h-10 px-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200"
            >
                  <FolderIcon class="h-4 w-4 mr-2" />
                  分组管理
            </button>
                <button
                  v-if="canManageCustomFields"
                  @click="handleManageCustomFields"
                  class="inline-flex items-center justify-center h-10 px-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200"
                >
                  <CogIcon class="h-4 w-4 mr-2" />
                  <span class="hidden sm:inline">自定义字段</span>
                  <span class="sm:hidden">自定义字段</span>
                </button>
              </div>
              
              <!-- 第二排：字段配置（手机端单独一行，桌面端与上面同行） -->
              <div class="sm:inline-flex">
            <button
                  @click="handleFieldConfig"
                  class="inline-flex items-center justify-center h-10 px-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 w-full sm:w-auto"
            >
                  <AdjustmentsHorizontalIcon class="h-4 w-4 mr-2" />
                  字段配置
            </button>
              </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 邮件账户列表 -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <!-- Loading 状态 -->
      <div v-if="loading" class="flex items-center justify-center py-20">
        <div class="text-center">
          <svg class="animate-spin h-8 w-8 text-blue-600 mx-auto mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p class="text-gray-600 text-lg">加载中...</p>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-else-if="!loading && accounts.length === 0" class="flex items-center justify-center py-20">
        <div class="text-center text-gray-500">
          <svg class="mx-auto h-12 w-12 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <p class="text-lg font-medium mb-2">暂无邮件账户</p>
          <p class="text-sm">点击上方"添加账户"按钮创建第一个邮件账户</p>
        </div>
      </div>

      <!-- 账户列表表格 -->
      <div v-else>
        <!-- 桌面端表格视图 -->
        <div class="hidden sm:block relative">
          <div class="flex overflow-hidden" ref="tableContainer">
            <!-- 左侧滚动区域：主要数据列 -->
            <div 
              class="flex-1 overflow-x-auto table-container" 
              ref="leftTableContainer"
            >
              <table class="w-full table-auto min-w-max">
          <thead class="bg-gray-50">
            <tr>
                    <th 
                      v-for="fieldConfig in visibleDataFieldConfigs" 
                      :key="`header-${fieldConfig.field_name}`"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider h-[52px]"
                      :style="{ width: fieldConfig.column_width ? `${fieldConfig.column_width}px` : 'auto' }"
                    >
                      {{ fieldConfig.field_label }}
              </th>
              <!-- 固定的同步状态列 -->
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider h-[52px]" style="width: 120px;">
                同步状态
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="account in paginatedAccounts" :key="`data-${account.id}`" class="hover:bg-gray-50 group" style="height: 72px;">
                    <td 
                      v-for="fieldConfig in visibleDataFieldConfigs" 
                      :key="`data-${account.id}-${fieldConfig.field_name}`"
                      class="px-6 py-4 text-sm text-gray-500 align-middle"
                      :style="{ 
                        height: '72px', 
                        verticalAlign: 'middle',
                        width: fieldConfig.column_width ? `${fieldConfig.column_width}px` : 'auto'
                      }"
                    >
                      <!-- 字段值渲染 -->
                      <template v-if="renderFieldValue(account, fieldConfig)?.type === 'provider'">
                        <div class="flex items-center h-10" style="max-height: 40px;">
                          <span
                            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                            :class="getProviderBadgeClass(account.provider)"
                          >
                            {{ renderFieldValue(account, fieldConfig).value }}
                          </span>
                </div>
                      </template>
              
                      <template v-else-if="renderFieldValue(account, fieldConfig)?.type === 'group'">
                        <div class="flex items-center h-10" style="max-height: 40px;">
                <span
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                            :style="{ 
                              backgroundColor: renderFieldValue(account, fieldConfig).color + '20',
                              color: renderFieldValue(account, fieldConfig).color
                            }"
                >
                            {{ renderFieldValue(account, fieldConfig).value }}
                </span>
                        </div>
                      </template>
                      
                      <template v-else-if="renderFieldValue(account, fieldConfig)?.type === 'assigned_to'">
                        <div class="flex items-center h-10" style="max-height: 40px;">
                          <div class="flex flex-wrap gap-1">
                            <template v-if="renderFieldValue(account, fieldConfig).value.length === 0">
                              <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600">
                                未分配
                              </span>
                            </template>
                            <template v-else>
                              <span
                                v-for="user in renderFieldValue(account, fieldConfig).value.slice(0, 2)"
                                :key="user.id"
                                class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800"
                                :title="`${user.name} (${user.email})`"
                              >
                                {{ user.name }}
                              </span>
                              <span
                                v-if="renderFieldValue(account, fieldConfig).value.length > 2"
                                class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600"
                                :title="renderFieldValue(account, fieldConfig).value.slice(2).map(u => `${u.name} (${u.email})`).join(', ')"
                              >
                                +{{ renderFieldValue(account, fieldConfig).value.length - 2 }}
                              </span>
                            </template>
                          </div>
                        </div>
                      </template>
                      
                      <template v-else-if="renderFieldValue(account, fieldConfig)?.type === 'number'">
                        <div class="flex items-center h-10" style="max-height: 40px;">
                          <span class="text-gray-900 font-medium">
                            {{ renderFieldValue(account, fieldConfig).value.toLocaleString() }}
                          </span>
                        </div>
                      </template>
                      
                      <!-- 普通字段显示 -->
                      <template v-else>
                        <div 
                          class="w-full overflow-hidden"
                          :title="renderFieldValue(account, fieldConfig)"
                          style="line-height: 1.2; max-height: 40px; display: flex; align-items: center;"
                        >
                          <span 
                            class="block truncate w-full text-gray-900"
                            style="white-space: nowrap;"
                          >
                            {{ renderFieldValue(account, fieldConfig) }}
                          </span>
                        </div>
                      </template>
                </td>
                
                <!-- 固定的同步状态列 -->
                <td 
                  class="px-6 py-4 text-sm text-gray-500 align-middle"
                  style="height: 72px; vertical-align: middle; width: 120px;"
                >
                  <div class="flex items-center h-10" style="max-height: 40px;">
                    <span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium cursor-pointer"
                      :class="getSyncStatusBadgeClass(getEffectiveSyncStatus(account))"
                      :title="getSyncStatusTooltip(account)"
                      @click="canShowSyncErrorDetail(account) ? showSyncErrorDetail(account) : null"
                    >
                      <component :is="getSyncStatusIcon(getEffectiveSyncStatus(account))" class="h-3 w-3 mr-1" />
                      {{ getSyncStatusLabel(account) }}
                    </span>
                  </div>
                </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 右侧固定列：操作 -->
            <div 
              v-if="actionFieldConfig && actionFieldConfig.is_visible"
              class="flex-shrink-0 bg-gray-50"
              :style="{ width: `${actionColumnWidth}px` }"
              ref="rightTableContainer"
            >
              <table class="w-full" :style="{ width: `${actionColumnWidth}px` }">
                <thead class="bg-gray-100">
                  <tr>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider h-[52px]">
                      {{ actionFieldConfig.field_label }}
              </th>
                  </tr>
                </thead>
                <tbody class="bg-gray-50 divide-y divide-gray-200">
                  <tr v-for="account in paginatedAccounts" :key="`action-${account.id}`" class="hover:bg-gray-100 group" style="height: 72px;">
                    <td class="px-6 py-4 text-sm text-gray-500 group-hover:bg-gray-100 transition-colors align-middle" style="height: 72px; vertical-align: middle;">
                      <div class="flex items-center justify-start space-x-2 h-10" style="max-height: 40px;">
                  <!-- 邮件同步 -->
                  <button
                    @click="handleSyncTest(account)"
                    :disabled="account.syncing"
                    class="inline-flex items-center text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded text-xs transition-colors disabled:opacity-50"
                    title="邮件同步"
                  >
                    <ArrowPathIcon class="h-4 w-4 mr-1" :class="{ 'animate-spin': account.syncing }" />
                    同步测试
                  </button>
                  
                  <!-- 发件测试 -->
                  <button
                    @click="handleSendTest(account)"
                    :disabled="account.testing"
                    class="inline-flex items-center text-green-600 hover:text-green-900 bg-green-50 hover:bg-green-100 px-2 py-1 rounded text-xs transition-colors disabled:opacity-50"
                    title="发件测试"
                  >
                    <PaperAirplaneIcon class="h-4 w-4 mr-1" />
                    发件测试
                  </button>
                  
                  <!-- 同步客户 -->
                  <button
                    @click="handleSyncCustomers(account)"
                    :disabled="account.syncingCustomers"
                    class="inline-flex items-center text-purple-600 hover:text-purple-900 bg-purple-50 hover:bg-purple-100 px-2 py-1 rounded text-xs transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    title="同步客户"
                  >
                    <svg v-if="account.syncingCustomers" class="animate-spin h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <UserPlusIcon v-else class="h-4 w-4 mr-1" />
                    {{ account.syncingCustomers ? '同步中...' : '同步客户' }}
                  </button>
                        
                        <!-- 恢复启用（仅停用账户显示） -->
                        <button
                          v-if="account.is_active === false && canRestoreEmailAccount"
                          @click="handleRestoreAccount(account)"
                          :disabled="account.restoring"
                          class="inline-flex items-center text-amber-700 hover:text-amber-900 bg-amber-50 hover:bg-amber-100 px-2 py-1 rounded text-xs transition-colors border border-amber-200 disabled:opacity-50 disabled:cursor-not-allowed"
                          title="恢复启用该账户并清空失败计数"
                        >
                          <svg v-if="account.restoring" class="animate-spin h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          <PlayCircleIcon v-else class="h-4 w-4 mr-1" />
                          {{ account.restoring ? '恢复中...' : '恢复启用' }}
                        </button>

                        <!-- 编辑账户 -->
                        <button
                          @click="handleEditAccount(account)"
                          class="inline-flex items-center text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded text-xs transition-colors"
                          title="编辑账户"
                        >
                          <PencilIcon class="h-4 w-4 mr-1" />
                          编辑
                  </button>
                  
                  <!-- 删除账户 -->
                  <button
                    v-if="canDeleteEmailAccount"
                    @click="handleDeleteAccount(account)"
                    :disabled="account.deleting"
                    class="inline-flex items-center text-red-600 hover:text-red-900 bg-red-50 hover:bg-red-100 px-2 py-1 rounded text-xs transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    title="删除账户"
                  >
                    <TrashIcon v-if="!account.deleting" class="h-4 w-4 mr-1" />
                    <svg v-else class="animate-spin h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 0 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                          {{ account.deleting ? '删除中...' : '删除' }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
            </div>
          </div>
        </div>

        <!-- 手机端卡片视图 -->
        <div class="block sm:hidden space-y-4">
          <!-- 邮件账户卡片列表 -->
          <div
            v-for="account in paginatedAccounts"
            :key="account.id"
            class="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <!-- 卡片头部 -->
            <div class="p-4 border-b border-gray-100">
              <div class="flex items-start justify-between">
                <div class="flex-1 min-w-0">
                  <!-- 邮件账户基本信息 -->
                  <h3 class="text-base font-medium text-gray-900 truncate">
                    {{ account.display_name || account.email }}
                  </h3>
                  <p class="text-sm text-gray-500 truncate">{{ account.email }}</p>
                  <div class="flex flex-wrap gap-2 mt-2">
                    <!-- 服务提供商 -->
                    <span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                      :class="getProviderBadgeClass(account.provider)"
                    >
                      {{ account.provider === 'outlook' ? 'Outlook' : account.provider === 'gmail' ? 'Gmail' : account.provider === '163' ? '163邮箱' : account.provider === 'aliyun' ? '阿里云邮箱' : account.provider === 'custom' ? '自定义邮箱' : account.provider }}
                    </span>
                    <!-- 分组 -->
                    <span
                      v-if="account.group"
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                      :style="{ 
                        backgroundColor: account.group.color + '20',
                        color: account.group.color
                      }"
                    >
                      {{ account.group.name }}
                    </span>
                    <!-- 同步状态 -->
                    <span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium cursor-pointer"
                      :class="getSyncStatusBadgeClass(getEffectiveSyncStatus(account))"
                      :title="getSyncStatusTooltip(account)"
                      @click="canShowSyncErrorDetail(account) ? showSyncErrorDetail(account) : null"
                    >
                      <component :is="getSyncStatusIcon(getEffectiveSyncStatus(account))" class="h-3 w-3 mr-1" />
                      {{ getSyncStatusLabel(account) }}
                    </span>
                  </div>
                </div>
                <!-- 时间 -->
                <div class="text-xs text-gray-400 ml-2">
                  {{ formatDate(account.created_at).split(' ')[0] }}
                </div>
              </div>
            </div>

            <!-- 卡片内容 -->
            <div class="p-4 space-y-3">
              <!-- 邮件统计 -->
              <div class="flex items-center justify-between">
                <div class="flex items-center space-x-4">
                  <div class="text-center">
                    <div class="text-sm font-medium text-gray-900">{{ account.inbox_count || 0 }}</div>
                    <div class="text-xs text-gray-500">收件</div>
                  </div>
                  <div class="text-center">
                    <div class="text-sm font-medium text-gray-900">{{ account.sent_count || 0 }}</div>
                    <div class="text-xs text-gray-500">发件</div>
                  </div>
                  <div class="text-center">
                    <div class="text-sm font-medium text-gray-900">{{ account.unread_count || 0 }}</div>
                    <div class="text-xs text-gray-500">未读</div>
                  </div>
                </div>
              </div>

              <!-- 最后同步时间 -->
              <div v-if="account.last_sync_time" class="flex items-start space-x-2">
                <span class="text-xs font-medium text-gray-500 mt-0.5">最后同步:</span>
                <span class="text-sm text-gray-900 flex-1 leading-relaxed">{{ formatDate(account.last_sync_time) }}</span>
              </div>

              <!-- 分配给 -->
              <div v-if="account.assigned_to && account.assigned_to.length > 0" class="flex items-start space-x-2">
                <span class="text-xs font-medium text-gray-500 mt-0.5">分配给:</span>
                <div class="flex flex-wrap gap-1 flex-1">
                  <span
                    v-for="user in account.assigned_to.slice(0, 2)"
                    :key="user.id"
                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800"
                    :title="`${user.name} (${user.email})`"
                  >
                    {{ user.name }}
                  </span>
                  <span
                    v-if="account.assigned_to.length > 2"
                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600"
                    :title="account.assigned_to.slice(2).map(u => `${u.name} (${u.email})`).join(', ')"
                  >
                    +{{ account.assigned_to.length - 2 }}
                  </span>
                </div>
              </div>

              <!-- 自定义字段 -->
              <div v-if="account.custom_fields && account.custom_fields.length > 0">
                <div class="flex items-center space-x-2 mb-2">
                  <span class="text-xs font-medium text-gray-500">自定义字段:</span>
                </div>
                <div class="space-y-2">
                  <div
                    v-for="field in account.custom_fields"
                    :key="field.field_id"
                    class="flex items-start space-x-2"
                  >
                    <span class="text-xs font-medium text-gray-500 mt-0.5">{{ field.label }}:</span>
                    <span class="text-sm text-gray-900 flex-1 leading-relaxed">{{ field.value || '-' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 卡片底部操作 -->
            <div class="px-4 py-3 bg-gray-50 border-t border-gray-100 rounded-b-lg">
              <div class="flex items-center justify-between space-x-2">
                <div class="flex items-center space-x-2">
                  <!-- 邮件同步 -->
                  <button
                    @click="handleSyncTest(account)"
                    :disabled="account.syncing"
                    class="inline-flex items-center text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-3 py-2 rounded-md text-xs font-medium transition-colors border border-blue-200 disabled:opacity-50"
                    title="邮件同步"
                  >
                    <ArrowPathIcon class="h-4 w-4 mr-1" :class="{ 'animate-spin': account.syncing }" />
                    同步
                  </button>

                  <!-- 发件测试 -->
                  <button
                    @click="handleSendTest(account)"
                    :disabled="account.testing"
                    class="inline-flex items-center text-green-600 hover:text-green-900 bg-green-50 hover:bg-green-100 px-3 py-2 rounded-md text-xs font-medium transition-colors border border-green-200 disabled:opacity-50"
                    title="发件测试"
                  >
                    <PaperAirplaneIcon class="h-4 w-4 mr-1" />
                    发件
                  </button>

                  <!-- 同步客户 -->
                  <button
                    @click="handleSyncCustomers(account)"
                    :disabled="account.syncingCustomers"
                    class="inline-flex items-center text-purple-600 hover:text-purple-900 bg-purple-50 hover:bg-purple-100 px-3 py-2 rounded-md text-xs font-medium transition-colors border border-purple-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    title="同步客户"
                  >
                    <svg v-if="account.syncingCustomers" class="animate-spin h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <UserPlusIcon v-else class="h-4 w-4 mr-1" />
                    {{ account.syncingCustomers ? '同步中...' : '同步' }}
                  </button>

                  <!-- 恢复启用（仅停用账户显示） -->
                  <button
                    v-if="account.is_active === false && canRestoreEmailAccount"
                    @click="handleRestoreAccount(account)"
                    :disabled="account.restoring"
                    class="inline-flex items-center text-amber-700 hover:text-amber-900 bg-amber-50 hover:bg-amber-100 px-3 py-2 rounded-md text-xs font-medium transition-colors border border-amber-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    title="恢复启用该账户并清空失败计数"
                  >
                    <svg v-if="account.restoring" class="animate-spin h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <PlayCircleIcon v-else class="h-4 w-4 mr-1" />
                    {{ account.restoring ? '恢复中...' : '恢复' }}
                  </button>

                  <!-- 编辑 -->
                  <button
                    @click="handleEditAccount(account)"
                    class="inline-flex items-center text-gray-600 hover:text-gray-900 bg-white hover:bg-gray-50 px-3 py-2 rounded-md text-xs font-medium transition-colors border border-gray-200"
                    title="编辑账户"
                  >
                    <PencilIcon class="h-4 w-4 mr-1" />
                    编辑
                  </button>
                </div>

                <!-- 删除 -->
                <button
                  v-if="canDeleteEmailAccount"
                  @click="handleDeleteAccount(account)"
                  :disabled="account.deleting"
                  class="inline-flex items-center text-red-600 hover:text-red-900 bg-red-50 hover:bg-red-100 px-3 py-2 rounded-md text-xs font-medium transition-colors border border-red-200 disabled:opacity-50 disabled:cursor-not-allowed"
                  title="删除账户"
                >
                  <TrashIcon v-if="!account.deleting" class="h-4 w-4 mr-1" />
                  <svg v-else class="animate-spin h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 0 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  {{ account.deleting ? '删除中...' : '删除' }}
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
      
      <!-- 分页 -->
      <div v-if="accounts.length > 0" class="bg-white border-t border-gray-200 rounded-b-lg shadow-sm">
        <!-- 移动端分页：分页按钮和每页数量选择器 -->
        <div class="px-4 py-3 sm:hidden">
            <div class="flex justify-between items-center">
          <button
            @click="prevPage"
                :disabled="currentPage === 1 || loading"
            class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
          >
            上一页
          </button>
              
              <!-- 每页数量选择器 -->
              <div class="flex items-center space-x-2">
                <span class="text-sm text-gray-700">每页</span>
                <select
                  v-model="pageSize"
                  @change="handlePageSizeChange"
                  class="border border-gray-300 rounded-md px-3 py-1 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent min-w-[60px] w-auto"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="text-sm text-gray-700">条</span>
              </div>
              
          <button
            @click="nextPage"
                :disabled="currentPage === totalPages || loading"
                class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
          >
            下一页
          </button>
        </div>
        </div>
          
          <!-- 桌面端分页：显示完整信息 -->
          <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between px-6 py-3">
            <div class="flex items-center space-x-4">
              <span class="text-sm text-gray-700">
                显示第 {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, totalAccounts) }} 条，
                共 {{ totalAccounts }} 条记录
              </span>
              
              <!-- 每页数量选择器 -->
              <div class="flex items-center space-x-2">
                <span class="text-sm text-gray-700">每页</span>
                <select
                  v-model="pageSize"
                  @change="handlePageSizeChange"
                  class="border border-gray-300 rounded-md px-3 py-1 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent min-w-[60px] w-auto"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="text-sm text-gray-700">条</span>
              </div>
            </div>
            <div class="flex items-center space-x-2">
              <button
                @click="prevPage"
                :disabled="currentPage === 1 || loading"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <ChevronLeftIcon class="h-4 w-4" />
                上一页
              </button>
              <span class="px-3 py-2 text-sm font-medium text-gray-700">
                第 {{ currentPage }} / {{ totalPages }} 页
              </span>
              <button
                @click="nextPage"
                :disabled="currentPage === totalPages || loading"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                下一页
                <ChevronRightIcon class="h-4 w-4" />
              </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加邮件账户弹窗 -->
    <AddEmailAccountModal 
      :visible="showAddModal" 
      :groups="groups"
      @close="showAddModal = false"
      @success="handleAddSuccess"
    />

    <!-- 发件测试弹窗 -->
    <div v-if="showSendTestModal" class="fixed inset-0 z-50 overflow-y-auto">
      <!-- 背景遮罩 -->
      <div class="fixed inset-0 bg-black bg-opacity-50 transition-opacity" @click="cancelSendTest"></div>
      
      <!-- 弹窗内容 -->
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative w-full max-w-lg bg-white rounded-xl shadow-2xl">
          <!-- 头部 -->
          <div class="flex items-center justify-between p-6 border-b border-gray-200">
            <h3 class="text-lg font-semibold text-gray-900">邮件发送测试</h3>
            <button
              @click="cancelSendTest"
              class="text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-lg p-1"
            >
              <XMarkIcon class="h-6 w-6" />
            </button>
          </div>

          <!-- 表单内容 -->
          <div class="p-6 space-y-4">
            <!-- 发送账户 -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">发送账户</label>
              <div class="bg-gray-50 px-3 py-2 rounded-lg border text-sm text-gray-600">
                {{ sendTestForm.account?.email }}
              </div>
            </div>

            <!-- 接收邮箱 -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                接收邮箱 <span class="text-red-500">*</span>
              </label>
              <input
                v-model="sendTestForm.toEmail"
                type="email"
                placeholder="请输入接收测试邮件的邮箱地址"
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                :disabled="sendingTest"
              >
            </div>

            <!-- 邮件主题 -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">邮件主题</label>
              <input
                v-model="sendTestForm.subject"
                type="text"
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                :disabled="sendingTest"
              >
            </div>

            <!-- 邮件内容 -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">邮件内容</label>
              <textarea
                v-model="sendTestForm.content"
                rows="6"
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none resize-none"
                :disabled="sendingTest"
              ></textarea>
            </div>
          </div>

          <!-- 底部按钮 -->
          <div class="flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
            <button
              @click="cancelSendTest"
              :disabled="sendingTest"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
            >
              取消
            </button>
            <button
              @click="sendTestEmail"
              :disabled="sendingTest || !sendTestForm.toEmail"
              class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 flex items-center space-x-2"
            >
              <svg v-if="sendingTest" class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <PaperAirplaneIcon v-else class="h-4 w-4" />
              <span>{{ sendingTest ? '发送中...' : '发送测试邮件' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 分组管理模态框 -->
    <EmailAccountGroupManagementModal 
      :show="showGroupManagementModal"
      :groups="groups"
      @close="closeGroupManagementModal"
      @success="handleGroupManagementSuccess"
    />

    <!-- 自定义字段管理模态框 -->
    <EmailAccountCustomFieldManagementModal 
      :show="showCustomFieldManagementModal"
      @close="closeCustomFieldManagementModal"
      @success="handleCustomFieldManagementSuccess"
    />

    <!-- 字段配置模态框 -->
    <EmailAccountFieldConfigModal 
      :show="showFieldConfigModal"
      @close="closeFieldConfigModal"
      @success="handleFieldConfigSuccess"
    />

    <!-- 编辑邮件账户模态框 -->
    <EditEmailAccountModal 
      :visible="showEditModal"
      :account="editingAccount"
      :groups="groups"
      :custom-fields-update-trigger="customFieldsUpdateTrigger"
      @close="showEditModal = false"
      @success="handleEditSuccess"
    />

    <!-- 同步客户模态框 -->
    <SyncCustomersModal
      :visible="showSyncCustomersModal"
      :account="syncingAccount"
      :tags="customerTags"
      :groups="customerGroups"
      @close="showSyncCustomersModal = false"
      @sync="handleSyncCustomersConfirm"
      ref="syncCustomersModalRef"
    />

    <!-- 同步错误详情模态框 -->
    <div v-if="showSyncErrorModal" class="fixed inset-0 z-50 overflow-y-auto">
      <!-- 背景遮罩 -->
      <div class="fixed inset-0 bg-black bg-opacity-50 transition-opacity" @click="closeSyncErrorModal"></div>
      
      <!-- 弹窗内容 -->
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative w-full max-w-2xl bg-white rounded-xl shadow-2xl">
          <!-- 头部 -->
          <div class="flex items-center justify-between p-6 border-b border-gray-200">
            <div class="flex items-center space-x-3">
              <div class="flex-shrink-0">
                <ExclamationCircleIcon class="h-8 w-8 text-red-600" />
              </div>
              <div>
                <h3 class="text-lg font-semibold text-gray-900">
                  {{ syncErrorAccount?.is_active === false ? '账户已停用' : '邮件同步错误详情' }}
                </h3>
                <p class="text-sm text-gray-500 mt-1">{{ syncErrorAccount?.email }}</p>
              </div>
            </div>
            <button
              @click="closeSyncErrorModal"
              class="text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-lg p-1"
            >
              <XMarkIcon class="h-6 w-6" />
            </button>
          </div>

          <!-- 内容 -->
          <div class="p-6 space-y-4">
            <!-- 错误统计信息 -->
            <div class="grid grid-cols-2 gap-4">
              <div class="bg-red-50 rounded-lg p-4 border border-red-200">
                <div class="text-sm font-medium text-red-600 mb-1">连续失败次数</div>
                <div class="text-2xl font-bold text-red-700">
                  {{ syncErrorAccount?.consecutive_failures || 0 }} 次
                </div>
              </div>
              <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                <div class="text-sm font-medium text-gray-600 mb-1">最后错误时间</div>
                <div class="text-sm font-medium text-gray-900">
                  {{ syncErrorAccount?.last_error_time ? formatDate(syncErrorAccount.last_error_time) : '-' }}
                </div>
              </div>
            </div>

            <!-- 错误详细信息 -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">错误信息</label>
              <div class="bg-gray-50 rounded-lg p-4 border border-gray-200 max-h-64 overflow-y-auto">
                <pre class="text-sm text-gray-800 whitespace-pre-wrap font-mono">{{ syncErrorAccount?.last_error || '暂无错误信息' }}</pre>
              </div>
            </div>

            <!-- 建议操作 -->
            <div class="bg-blue-50 rounded-lg p-4 border border-blue-200">
              <div class="flex items-start space-x-3">
                <ExclamationTriangleIcon class="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                <div class="flex-1">
                  <h4 class="text-sm font-medium text-blue-900 mb-2">建议操作</h4>
                  <ul class="text-sm text-blue-800 space-y-1 list-disc list-inside">
                    <li>检查邮箱账户密码是否正确</li>
                    <li>确认 IMAP/SMTP 服务器配置是否正确</li>
                    <li>检查网络连接是否正常</li>
                    <li>查看邮箱服务商是否有安全限制或需要授权</li>
                    <li v-if="syncErrorAccount?.consecutive_failures >= 3">连续失败次数过多，建议重新配置账户</li>
                    <li v-if="syncErrorAccount?.is_active === false">
                      该账户已停用、不再自动同步。修好密码或重新授权后，点击下方「恢复启用」重新纳入同步
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- 底部按钮 -->
          <div class="flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
            <button
              @click="closeSyncErrorModal"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              关闭
            </button>
            <button
              v-if="syncErrorAccount?.is_active === false && canRestoreEmailAccount"
              @click="handleRestoreAccount(syncErrorAccount); closeSyncErrorModal()"
              class="px-4 py-2 text-sm font-medium text-white bg-amber-600 border border-transparent rounded-lg hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500 flex items-center space-x-2"
            >
              <PlayCircleIcon class="h-4 w-4" />
              <span>恢复启用</span>
            </button>
            <button
              @click="handleSyncTest(syncErrorAccount); closeSyncErrorModal()"
              class="px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 flex items-center space-x-2"
            >
              <ArrowPathIcon class="h-4 w-4" />
              <span>重新同步</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useToast } from 'vue-toastification'
import { useAuthStore } from '@/stores/auth'
import {
  MagnifyingGlassIcon,
  UserPlusIcon,
  ArrowPathIcon,
  PaperAirplaneIcon,
  TrashIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDownIcon,
  XMarkIcon,
  CogIcon,
  AdjustmentsHorizontalIcon,
  PlusIcon,
  FolderIcon,
  PencilIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  ClockIcon,
  NoSymbolIcon,
  PlayCircleIcon
} from '@heroicons/vue/24/outline'
import emailAccountService from '@/services/emailAccountService'
import AddEmailAccountModal from '@/components/email/AddEmailAccountModal.vue'
import EditEmailAccountModal from '@/components/email/EditEmailAccountModal.vue'
import EmailAccountGroupManagementModal from '@/components/email/EmailAccountGroupManagementModal.vue'
import EmailAccountCustomFieldManagementModal from '@/components/email/EmailAccountCustomFieldManagementModal.vue'
import EmailAccountFieldConfigModal from '@/components/email/EmailAccountFieldConfigModal.vue'
import SyncCustomersModal from '@/components/email/SyncCustomersModal.vue'
import SearchableSelect from '@/components/common/SearchableSelect.vue'

const toast = useToast()
const authStore = useAuthStore()

// 响应式数据
const searchQuery = ref('')
const selectedProvider = ref('')
const selectedGroup = ref('')
const currentPage = ref(1)
const pageSize = ref(10)
const accounts = ref([])
const loading = ref(true)
const totalAccounts = ref(0)
const apiError = ref('')
const fieldConfigs = ref([]) // 字段配置
const groups = ref([]) // 分组列表
const selectedAccountForRemoval = ref(null)

// 批量操作
const selectedAccounts = ref([])

// 模态框状态
const showGroupManagementModal = ref(false)
const showCustomFieldManagementModal = ref(false)
const showFieldConfigModal = ref(false)
const showEditModal = ref(false)
const editingAccount = ref(null)
const customFieldsUpdateTrigger = ref(0)
const showSyncCustomersModal = ref(false)
const syncingAccount = ref(null)
const syncCustomersModalRef = ref(null)

// 客户标签和分组
const customerTags = ref([])
const customerGroups = ref([])

// 同步错误详情模态框
const showSyncErrorModal = ref(false)
const syncErrorAccount = ref(null)


// 计算属性
const isSubAccount = computed(() => {
  return authStore.user?.account_type === 'sub'
})

// 🔧 子账号不能管理（创建/编辑/删除）自定义字段
const canManageCustomFields = computed(() => {
  return !isSubAccount.value
})

const canAddEmailAccount = computed(() => {
  // 子账户也可以添加邮箱：账户归属主账户，并自动分配给该子账户（后端处理）
  return true
})

const canDeleteEmailAccount = computed(() => {
  return !isSubAccount.value
})

// 账户启停属于账户级管理操作，子账户不可恢复启用（后端同样拦截）
const canRestoreEmailAccount = computed(() => {
  return !isSubAccount.value
})

const totalPages = computed(() => Math.ceil(totalAccounts.value / pageSize.value))

// 直接显示API返回的账户列表，不进行前端筛选
const paginatedAccounts = computed(() => accounts.value)

// 批量操作计算属性
const isAllSelected = computed(() => {
  return accounts.value.length > 0 && selectedAccounts.value.length === accounts.value.length
})

const isIndeterminate = computed(() => {
  return selectedAccounts.value.length > 0 && selectedAccounts.value.length < accounts.value.length
})

// 提供商选项格式化
const providerOptions = computed(() => {
  return [
    { id: '', name: '所有提供商' },
    { id: 'outlook', name: 'Outlook' },
    { id: 'gmail', name: 'Gmail' },
    { id: '163', name: '163邮箱' },
    { id: '163vip', name: '163VIP邮箱' },
    { id: 'aliyun', name: '阿里云企业邮箱' }
  ]
})

// 分组选项格式化（移除统计数字以减少不必要的数据需求）
const groupOptions = computed(() => {
  const options = [{ id: '', name: '所有分组' }]
  groups.value.forEach(group => {
    options.push({
      id: group.id,
      name: group.name
    })
  })
  return options
})

// 可见字段配置（按排序顺序）
const visibleFieldConfigs = computed(() => {
  return fieldConfigs.value
    .filter(config => config.is_visible)
    .sort((a, b) => a.sort_order - b.sort_order)
})

// 可见数据字段（除了操作列和同步状态列）
const visibleDataFieldConfigs = computed(() => {
  return visibleFieldConfigs.value.filter(config => 
    config.field_name !== 'actions' && config.field_name !== 'sync_status'
  )
})

// 操作列配置
const actionFieldConfig = computed(() => {
  return visibleFieldConfigs.value.find(config => config.field_name === 'actions')
})

// 当前页是否存在停用账户（决定操作列是否需要为「恢复启用」按钮留出宽度）
const hasInactiveAccountInPage = computed(() => {
  return accounts.value.some(account => account.is_active === false)
})

// 操作列宽度
const actionColumnWidth = computed(() => {
  // 🔧 根据权限动态调整操作列宽度
  // 主账号有4个按钮（同步、发件测试、编辑、删除），子账号有3个按钮（无删除）
  // 停用账户行会多出「恢复启用」按钮，需额外预留宽度避免挤压
  const restoreExtra = (hasInactiveAccountInPage.value && canRestoreEmailAccount.value) ? 100 : 0
  const configWidth = actionFieldConfig.value?.column_width
  if (!configWidth) {
    return 200 + restoreExtra
  }
  
  // 如果无删除权限（子账号），减少操作列宽度
  if (!canDeleteEmailAccount.value) {
    // 减少约80px（删除按钮的宽度 + 间距）
    return Math.max(configWidth - 60, 280) + restoreExtra
  }
  
  return configWidth + restoreExtra
})


// 方法
const getProviderName = (provider) => {
  const providerMap = {
    'outlook': 'Outlook',
    'gmail': 'Gmail',
    '163': '163邮箱',
    '163vip': '163VIP邮箱',
    'aliyun': '阿里云企业邮箱'
  }
  return providerMap[provider] || provider
}

const getProviderBadgeClass = (provider) => {
  const classMap = {
    'outlook': 'bg-blue-100 text-blue-800',
    'gmail': 'bg-green-100 text-green-800',
    '163': 'bg-red-100 text-red-800',
    '163vip': 'bg-gray-100 text-gray-800',
    'aliyun': 'bg-orange-100 text-orange-800'
  }
  return classMap[provider] || 'bg-gray-100 text-gray-800'
}

// 获取同步状态样式
const getSyncStatusBadgeClass = (status) => {
  const classMap = {
    'normal': 'bg-green-100 text-green-800 border border-green-200',
    'syncing': 'bg-blue-100 text-blue-800 border border-blue-200',
    'error': 'bg-red-100 text-red-800 border border-red-200 hover:bg-red-200',
    'warning': 'bg-yellow-100 text-yellow-800 border border-yellow-200',
    'disabled': 'bg-gray-200 text-gray-700 border border-gray-300 hover:bg-gray-300'
  }
  return classMap[status] || 'bg-gray-100 text-gray-800 border border-gray-200'
}

// 获取同步状态图标
const getSyncStatusIcon = (status) => {
  const iconMap = {
    'normal': CheckCircleIcon,
    'syncing': ClockIcon,
    'error': ExclamationCircleIcon,
    'warning': ExclamationTriangleIcon,
    'disabled': NoSymbolIcon
  }
  return iconMap[status] || ClockIcon
}

// 停用账户不参与任何同步，状态一律以"已停用"呈现
// （历史数据存在 is_active=False 但 sync_status 残留为 normal 的情况，避免误显示为正常）
const getEffectiveSyncStatus = (account) => {
  return account.is_active === false ? 'disabled' : account.sync_status
}

// 状态徽标文案
const getSyncStatusLabel = (account) => {
  if (account.is_active === false) return '已停用'
  return account.sync_status_display || '未知'
}

// 徽标是否可点击查看错误详情（停用账户的停用原因也记录在 last_error 中）
const canShowSyncErrorDetail = (account) => {
  return account.sync_status === 'error' || account.is_active === false
}

// 获取同步状态提示信息
const getSyncStatusTooltip = (account) => {
  const failureInfo = account.consecutive_failures > 0
    ? `（连续失败 ${account.consecutive_failures} 次）`
    : ''

  if (account.is_active === false) {
    return `账户已停用${failureInfo}，不会自动同步新邮件，点击查看原因`
  } else if (account.sync_status === 'error') {
    return `同步失败${failureInfo}，点击查看详情`
  } else if (account.sync_status === 'syncing') {
    return '正在同步中...'
  } else if (account.sync_status === 'normal') {
    return '同步正常'
  } else if (account.sync_status === 'warning') {
    return '同步警告'
  }
  return '同步状态未知'
}

// 显示同步错误详情
const showSyncErrorDetail = (account) => {
  syncErrorAccount.value = account
  showSyncErrorModal.value = true
}

// 关闭同步错误详情模态框
const closeSyncErrorModal = () => {
  showSyncErrorModal.value = false
  syncErrorAccount.value = null
}

const formatDate = (dateString) => {
  if (!dateString) return '-'
  const date = new Date(dateString)
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit', 
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).replace(/\//g, '-')
}

// 批量操作方法
const toggleSelectAll = () => {
  if (isAllSelected.value) {
    selectedAccounts.value = []
  } else {
    selectedAccounts.value = accounts.value.map(account => account.id)
  }
}

// 渲染字段值
const renderFieldValue = (account, fieldConfig) => {
  const fieldName = fieldConfig.field_name
  
  // 处理自定义字段
  if (fieldConfig.field_type === 'custom') {
    const customFieldValue = account.custom_fields?.find(
      value => value.field_id === parseInt(fieldName)
    )
    return customFieldValue?.value || '-'
  }
  
  // 处理系统字段
  switch (fieldName) {
    case 'email':
      return account.email || '-'
    case 'display_name':
      return account.display_name || account.email || '-'
    case 'group':
      return {
        type: 'group',
        value: account.group ? account.group.name : '未分组',
        color: account.group ? account.group.color : '#6b7280'
      }
    case 'provider':
      return {
        type: 'provider',
        value: getProviderName(account.provider)
      }
    case 'assigned_to':
      return {
        type: 'assigned_to',
        value: account.assigned_to || []
      }
    case 'inbox_count':
    case 'sent_count':
      return {
        type: 'number',
        value: account[fieldName] || 0
      }
    case 'last_sync':
      return formatDate(account.last_sync_time)
    default:
      return account[fieldName] || '-'
  }
}

// 事件处理
const handleSearch = async () => {
  // 立即滚动到顶部
  window.scrollTo({
    top: 0,
    behavior: 'instant'
  })
  
  currentPage.value = 1
  await loadEmailAccountsFromAPI(true)
  
  // 构建搜索提示信息
  const searchInfo = []
  if (searchQuery.value) {
    searchInfo.push(`关键词: "${searchQuery.value}"`)
  }
  if (selectedGroup.value) {
    const group = groups.value.find(g => g.id == selectedGroup.value)
    searchInfo.push(`分组: ${group ? group.name : selectedGroup.value}`)
  }
  if (selectedProvider.value) {
    searchInfo.push(`提供商: ${getProviderName(selectedProvider.value)}`)
  }
  
}

const handleClearSearch = async () => {
  // 立即滚动到顶部
  window.scrollTo({
    top: 0,
    behavior: 'instant'
  })
  
  searchQuery.value = ''
  selectedGroup.value = ''
  selectedProvider.value = ''
  currentPage.value = 1
  await loadEmailAccountsFromAPI(false)
  toast.info('已清空搜索条件')
}

const showAddModal = ref(false)

// 发件测试弹窗状态
const showSendTestModal = ref(false)
const sendTestForm = ref({
  account: null,
  toEmail: '',
  subject: '',
  content: ''
})
const sendingTest = ref(false)

const handleAddAccount = () => {
  showAddModal.value = true
}

const handleAddSuccess = () => {
  // 重新加载账户列表
  loadEmailAccountsFromAPI(true)
}


const handleSyncTest = async (account) => {
  account.syncing = true
  toast.info(`开始邮件同步: ${account.email}`)
  
  try {
    const result = await emailAccountService.syncEmailAccount(account.id, { force: true })
    
    // 更新同步时间
    const syncTime = result.data?.sync_time || new Date().toISOString()
    account.last_sync_time = syncTime
    account.last_sync = syncTime
    
    // 从正确的路径提取统计信息
    const statistics = result.data?.sync_results?.statistics
    
    if (statistics) {
      // 使用API返回的统计信息更新账户数据
      account.inbox_count = statistics.inbox_count || 0
      account.sent_count = statistics.sent_count || 0
      account.total_emails = statistics.total_emails || 0
      account.unread_count = statistics.inbox_unread_count || 0
      
      // 显示详细的同步结果
      const details = []
      if (account.inbox_count > 0) details.push(`收件 ${account.inbox_count} 封`)
      if (account.sent_count > 0) details.push(`发件 ${account.sent_count} 封`)
      if (account.unread_count > 0) details.push(`未读 ${account.unread_count} 封`)
      
      const successMsg = details.length > 0 
        ? `同步完成！${details.join('，')}`
        : '邮件同步完成'
      
      toast.success(successMsg)
    } else {
      // 如果API结构不符合预期，直接使用API返回的消息
      if (result.success && result.message) {
        toast.success(result.message)
      } else {
        toast.success(`${account.email} 邮件同步完成`)
      }
      
      // 尝试重新加载账户数据来获取最新统计
      try {
        const accountDetail = await emailAccountService.getEmailAccount(account.id)
        if (accountDetail) {
          account.inbox_count = accountDetail.inbox_count || 0
          account.sent_count = accountDetail.sent_count || 0
          account.total_emails = accountDetail.total_emails || 0
          account.unread_count = accountDetail.unread_count || 0
        }
      } catch (detailError) {
        console.warn('获取账户详情失败:', detailError)
      }
    }
    
  } catch (error) {
    console.error('邮件同步失败:', error)
    toast.error(`${account.email} 邮件同步失败: ${error.response?.data?.message || error.message}`)
  } finally {
    account.syncing = false
  }
}

const handleSendTest = (account) => {
  // 打开发件测试弹窗
  sendTestForm.value = {
    account: account,
    toEmail: '',
    subject: '发件测试 - BUBU.IM',
    content: `这是一封来自 BUBU.IM 系统的发件测试邮件。

发送账户：${account.email}
发送时间：${new Date().toLocaleString('zh-CN')}
测试系统：BUBU.IM 邮件聚合管理系统

如果您收到这封邮件，说明邮件发送功能已正常工作。`
  }
  showSendTestModal.value = true
}

// 实际发送测试邮件
const sendTestEmail = async () => {
  if (!sendTestForm.value.toEmail) {
    toast.error('请输入接收邮箱地址')
    return
  }
  
  // 简单的邮箱格式验证
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(sendTestForm.value.toEmail)) {
    toast.error('请输入有效的邮箱地址')
    return
  }
  
  sendingTest.value = true
  const account = sendTestForm.value.account
  
  try {
    const result = await emailAccountService.sendTestEmail(account.id, {
      recipient: sendTestForm.value.toEmail,
      subject: sendTestForm.value.subject,
      content: sendTestForm.value.content
    })
    
    toast.success(`测试邮件已发送到 ${sendTestForm.value.toEmail}`)
    showSendTestModal.value = false
    
    // 重置表单
    sendTestForm.value = {
      account: null,
      toEmail: '',
      subject: '',
      content: ''
    }
  } catch (error) {
    console.error('发件测试失败:', error)
    toast.error(`发件测试失败: ${error.response?.data?.message || error.message}`)
  } finally {
    sendingTest.value = false
  }
}

// 取消发件测试
const cancelSendTest = () => {
  showSendTestModal.value = false
  sendTestForm.value = {
    account: null,
    toEmail: '',
    subject: '',
    content: ''
  }
}

const handleDeleteAccount = async (account) => {
  if (confirm(`确定要删除邮件账户 ${account.email} 吗？此操作不可撤销。`)) {
    account.deleting = true
    toast.info(`正在删除邮件账户: ${account.email}`)
    
    try {
      await emailAccountService.deleteEmailAccount(account.id)
      
      // 直接从前端数组中移除被删除的账户
      const index = accounts.value.findIndex(acc => acc.id === account.id)
      if (index > -1) {
        accounts.value.splice(index, 1)
        // 更新总数
        totalAccounts.value = Math.max(0, totalAccounts.value - 1)
      }
      
      toast.success(`已删除邮件账户: ${account.email}`)
      
      // 如果当前页没有数据了且不是第一页，回到上一页
      if (accounts.value.length === 0 && currentPage.value > 1) {
        currentPage.value = currentPage.value - 1
        await loadEmailAccountsFromAPI(true)
      }
    } catch (error) {
      console.error('删除邮件账户失败:', error)
      toast.error(`删除邮件账户失败: ${error.response?.data?.message || error.message}`)
    } finally {
      account.deleting = false
    }
  }
}

// 恢复启用被停用/自动禁用的账户
const handleRestoreAccount = async (account) => {
  if (!confirm(`确定要恢复启用 ${account.email} 吗？\n\n将清空连续失败计数并重新纳入定时同步。请先确认密码或授权已修复，否则同步失败累计到 10 次后会再次被自动禁用。`)) {
    return
  }

  account.restoring = true

  try {
    const result = await emailAccountService.restoreAccount(account.id)

    // 就地更新该行状态，避免整页重载
    account.is_active = true
    account.sync_status = 'normal'
    account.sync_status_display = result.data?.sync_status_display || '正常'
    account.consecutive_failures = 0
    account.last_error = null
    account.last_error_time = null

    toast.success(result.message || `${account.email} 已恢复启用`)
  } catch (error) {
    console.error('恢复启用失败:', error)
    toast.error(error.message)
  } finally {
    account.restoring = false
  }
}

// 分页方法
const prevPage = async () => {
  if (currentPage.value > 1) {
    // 立即滚动到顶部
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    })
    
    currentPage.value--
    await loadEmailAccountsFromAPI(true)
  }
}

const nextPage = async () => {
  if (currentPage.value < totalPages.value) {
    // 立即滚动到顶部
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    })
    
    currentPage.value++
    await loadEmailAccountsFromAPI(true)
  }
}

const goToPage = async (page) => {
  // 立即滚动到顶部
  window.scrollTo({
    top: 0,
    behavior: 'instant'
  })
  
  currentPage.value = page
  await loadEmailAccountsFromAPI(true)
}

// 处理每页数量变化
const handlePageSizeChange = async () => {
  // 确保 pageSize 是数字类型
  pageSize.value = Number(pageSize.value)
  
  // 滚动到顶部
  window.scrollTo({
    top: 0,
    behavior: 'instant'
  })
  
  // 重置到第一页
  currentPage.value = 1
  
  // 重新加载数据
  await loadEmailAccountsFromAPI(true)
}

// 分组管理
const handleManageGroups = () => {
  showGroupManagementModal.value = true
}

const closeGroupManagementModal = () => {
  showGroupManagementModal.value = false
}

const handleGroupManagementSuccess = async () => {
  // 重新加载分组列表和邮件账户列表
  await loadGroups()
  await loadEmailAccountsFromAPI(false)
}

// 自定义字段管理
const handleManageCustomFields = () => {
  showCustomFieldManagementModal.value = true
}

const closeCustomFieldManagementModal = () => {
  showCustomFieldManagementModal.value = false
}

const handleCustomFieldManagementSuccess = async () => {
  // 重新加载字段配置以反映新增的自定义字段
  await loadFieldConfigs()
  // 重新加载账户列表以更新自定义字段值
  await loadEmailAccountsFromAPI(false)
  customFieldsUpdateTrigger.value++
}

// 字段配置管理
const handleFieldConfig = () => {
  showFieldConfigModal.value = true
}

const closeFieldConfigModal = () => {
  showFieldConfigModal.value = false
}

const handleFieldConfigSuccess = async () => {
  // 字段配置更新后，重新加载字段配置和账户列表
  await loadFieldConfigs()
  await loadEmailAccountsFromAPI(false)
}

// 加载字段配置
const loadFieldConfigs = async () => {
  try {
    const response = await emailAccountService.getVisibleFieldConfigs()
    if (response.success) {
      fieldConfigs.value = response.data || []
    }
  } catch (error) {
    console.error('加载字段配置失败:', error)
    // 如果加载失败，初始化默认配置
    try {
      await emailAccountService.initializeFieldConfigs()
      const retryResponse = await emailAccountService.getVisibleFieldConfigs()
      if (retryResponse.success) {
        fieldConfigs.value = retryResponse.data || []
      }
    } catch (initError) {
      console.error('初始化字段配置失败:', initError)
    }
  }
}

// 加载分组列表（统一使用page_size参数避免重复请求）
const loadGroups = async () => {
  try {
    const response = await emailAccountService.getEmailAccountGroups({
      page_size: 100
    })
    if (response.success && response.data.results) {
      groups.value = response.data.results
    } else {
      groups.value = []
      console.log('分组列表为空或加载失败')
    }
  } catch (error) {
    console.error('加载分组列表失败:', error)
    toast.error('加载分组列表失败')
    groups.value = []
  }
}

// API集成方法
const loadEmailAccountsFromAPI = async (useCurrentSearchTerms = true) => {
  loading.value = true
  try {
    const params = {
      search: useCurrentSearchTerms ? searchQuery.value : '',
      provider: useCurrentSearchTerms ? selectedProvider.value : '',
      group: useCurrentSearchTerms ? selectedGroup.value : '',
      page: currentPage.value,
      page_size: pageSize.value
    }
    const response = await emailAccountService.getEmailAccounts(params)
    accounts.value = response.results || []
    totalAccounts.value = response.count || 0
    
    // 更新分页信息
    if (response.count) {
      const calculatedTotalPages = Math.ceil(response.count / pageSize.value)
      // 如果总页数计算发生变化，确保当前页不超出范围
      if (currentPage.value > calculatedTotalPages && calculatedTotalPages > 0) {
        currentPage.value = calculatedTotalPages
        // 递归调用重新加载
        await loadEmailAccountsFromAPI()
        return
      }
    }
  } catch (error) {
    console.error('加载邮件账户失败:', error)
    toast.error('加载邮件账户失败')
    accounts.value = []
    totalAccounts.value = 0
  } finally {
    loading.value = false
  }
}

// 编辑邮件账户
const handleEditAccount = (account) => {
  editingAccount.value = account
  showEditModal.value = true
}

const handleEditSuccess = async (updatedAccount) => {
  showEditModal.value = false
  editingAccount.value = null
  
  // 直接更新本地账户列表中的对应项
  if (updatedAccount) {
    const index = accounts.value.findIndex(account => account.id === updatedAccount.id)
    if (index !== -1) {
      // 保持原有的自定义字段数据，只更新从API返回的字段
      accounts.value[index] = {
        ...accounts.value[index],
        ...updatedAccount
      }
    }
  }
  
  toast.success('邮件账户更新成功')
}

// 同步客户 - 打开模态框
const handleSyncCustomers = async (account) => {
  // 设置当前账户
  syncingAccount.value = account
  
  // 显示模态框（标签和分组已在页面加载时获取）
  showSyncCustomersModal.value = true
}

// 确认同步客户
const handleSyncCustomersConfirm = async (syncOptions) => {
  const account = syncingAccount.value
  
  try {
    // 设置同步状态（确保响应式）
    if (!account.hasOwnProperty('syncingCustomers')) {
      account.syncingCustomers = false
    }
    account.syncingCustomers = true
    
    // 调用API同步客户
    const result = await emailAccountService.syncCustomers(account.id, syncOptions)
    
    if (result.success) {
      const data = result.data
      const messages = []
      
      if (data.new_customers > 0) {
        messages.push(`新增 ${data.new_customers} 个客户`)
      }
      if (data.updated_customers > 0) {
        messages.push(`更新 ${data.updated_customers} 个客户`)
      }
      if (data.skipped_customers > 0) {
        messages.push(`跳过 ${data.skipped_customers} 个已存在客户`)
      }
      
      const successMsg = messages.length > 0 
        ? `客户同步完成！${messages.join('，')}`
        : `客户同步完成，共处理 ${data.total_processed} 条记录`
      
      toast.success(successMsg)
      
      // 关闭模态框
      showSyncCustomersModal.value = false
      syncingAccount.value = null
    } else {
      toast.error(result.error || '客户同步失败')
    }
  } catch (error) {
    console.error('同步客户失败:', error)
    
    // 检查具体的错误类型
    const errorMessage = error.response?.data?.message || error.message
    
    if (errorMessage?.includes('暂无邮件数据')) {
      toast.warning('该邮件账户暂无邮件数据，请先同步邮件')
    } else if (errorMessage?.includes('至少选择一个客户分组')) {
      toast.error('请至少选择一个客户分组')
    } else {
      toast.error(`同步客户失败: ${errorMessage}`)
    }
  } finally {
    account.syncingCustomers = false
    
    // 重置模态框的同步状态
    if (syncCustomersModalRef.value) {
      syncCustomersModalRef.value.setSyncing(false)
    }
  }
}

// 加载客户标签和分组
const loadCustomerTagsAndGroups = async () => {
  try {
    // 导入客户服务
    const { customerTagService, customerGroupService } = await import('@/services/customerService')
    
    // 加载标签
    const tagsResponse = await customerTagService.getTags()
    if (tagsResponse.success && tagsResponse.data.results) {
      customerTags.value = tagsResponse.data.results
    }
    
    // 加载分组
    const groupsResponse = await customerGroupService.getGroups()
    if (groupsResponse.success && groupsResponse.data.results) {
      customerGroups.value = groupsResponse.data.results
    }
  } catch (error) {
    console.error('加载客户标签和分组失败:', error)
    // 失败不影响打开模态框
  }
}

// 页面可见性变化处理（当用户从其他页面返回时刷新标签和分组）
const handleVisibilityChange = () => {
  if (!document.hidden) {
    // 页面变为可见时，重新加载客户标签和分组
    loadCustomerTagsAndGroups()
  }
}

// 生命周期
onMounted(async () => {
  // 检查是否是 OAuth 回调
  const urlParams = new URLSearchParams(window.location.search)
  const oauthSuccess = urlParams.get('oauth_success')
  const oauthError = urlParams.get('oauth_error')
  const email = urlParams.get('email')
  
  await Promise.all([
    loadFieldConfigs(), // 加载字段配置
    loadGroups(), // 加载分组列表
    loadCustomerTagsAndGroups() // 加载客户标签和分组（用于同步客户功能）
  ])
  
  // 如果是 OAuth 成功回调，稍微延迟加载以确保后端已创建记录
  if (oauthSuccess === 'true') {
    // 延迟 500ms 后加载，确保后端已经创建了 EmailAccount
    await new Promise(resolve => setTimeout(resolve, 500))
    await loadEmailAccountsFromAPI(false)
    
    // 显示成功消息
    toast.success(`邮件账户 ${email} 已成功添加！`, {
      timeout: 5000
    })
    
    // 清除 URL 参数
    window.history.replaceState({}, '', window.location.pathname)
  } else if (oauthError) {
    // 显示错误消息
    toast.error('OAuth 认证失败，请重试', {
      timeout: 5000
    })
    
    // 清除 URL 参数
    window.history.replaceState({}, '', window.location.pathname)
    
    await loadEmailAccountsFromAPI(false)
  } else {
    // 正常加载
    await loadEmailAccountsFromAPI(false)
  }
  
  // 监听页面可见性变化
  document.addEventListener('visibilitychange', handleVisibilityChange)
})

// 组件卸载时移除监听器
onBeforeUnmount(() => {
  document.removeEventListener('visibilitychange', handleVisibilityChange)
})
</script>

<style scoped>
/* 美化表格容器的水平滚动条 */
.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f8fafc;
  border-radius: 4px;
  margin: 0 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: linear-gradient(90deg, #e2e8f0, #cbd5e1);
  border-radius: 4px;
  transition: all 0.3s ease;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(90deg, #cbd5e1, #94a3b8);
  transform: scaleY(1.2);
}

/* Firefox 滚动条样式 */
.table-container {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f8fafc;
}

/* 表格文本处理 */
.table-container td {
  word-break: normal;
  overflow-wrap: normal;
}

</style>
